import { PayloadAction } from '@reduxjs/toolkit';
import { IApiError, IApiProblem } from '@/api';
import { all, put } from 'redux-saga/effects';
import { messageFactory } from '../messaging';

export function* handleSagaError(
	error: unknown,
	actions: PayloadAction<unknown>[]
) {
	console.error('handleSagaError', [error, actions]);
	if (isApiError(error)) {
		if (isApiProblem(error.data)) {
			yield all([
				put(
					messageFactory.apiErrorMessage({
						statusText: error.statusText,
						message: error.data.title,
						stack: error.data.detail,
						statusCode: error.data.status,
						data: ''
					})
				),
				...actions.map(a => put(a))
			]);
			return;
		}
		yield all([
			put(
				messageFactory.errorMessage({
					statusText: error.statusText,
					message: error.message,
					stack: error.stack,
					statusCode: error.statusCode,
					data: ''
				})
			),
			...actions.map(a => put(a))
		]);
		return;
	}

	if (isTypeError(error)) {
		yield all([
			put(
				messageFactory.errorMessage({
					statusText: error.name,
					message: error.message,
					stack: error.stack ?? '',
					statusCode: 0,
					data: ''
				})
			),
			...actions.map(a => put(a))
		]);
		return;
	}
	yield all([
		put(
			messageFactory.errorMessage({
				statusText: '',
				message: error as string,
				stack: '',
				statusCode: 0,
				data: ''
			})
		),
		...actions.map(a => put(a))
	]);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isApiError = (error: any): error is IApiError => {
	return error?.data !== undefined;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isApiProblem = (data: any): data is IApiProblem => {
	return data?.title !== undefined && data?.detail !== undefined;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isTypeError = (data: any): data is TypeError => {
	return data instanceof TypeError;
};
